import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "@src/utils/axios/AxiosProvider";
import { type LanTypes, getLanguageCode } from "@src/helpers";

export const KEY = "info/dialcodes";

export interface TDialCodes {
  countryID: number;
  countryName?: string;
  countryCode: string;
  flagURL: string;
  dialCode: string;
  minDIG: number;
  maxDIG: number;
}

const getDialCodes = async (language: LanTypes) => {
  const languageCode = getLanguageCode(language);

  const response = await axiosInstance.get<{ countries: TDialCodes[] }>(
    `api/info/dialcodes`,
    {
      params: {
        lang: languageCode,
      },
      headers: { langcode: languageCode },
    },
  );
  return response.data;
};

export const useDialCodes = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  return useQuery({
    queryKey: [KEY, i18n.language],
    queryFn: () => getDialCodes(i18n.language as LanTypes),
    onError() {
      navigate(`/${i18n.language}/error`);
    },
    staleTime: Infinity,
  });
};
